import { render } from "./CouponCard.vue?vue&type=template&id=51073c76&scoped=true"
import script from "./CouponCard.vue?vue&type=script&lang=js"
export * from "./CouponCard.vue?vue&type=script&lang=js"

import "./CouponCard.vue?vue&type=style&index=0&id=51073c76&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51073c76"]])

export default __exports__